import { render, staticRenderFns } from "./SecondChildAction.vue?vue&type=template&id=47405fe8&scoped=true&"
import script from "./SecondChildAction.vue?vue&type=script&lang=js&"
export * from "./SecondChildAction.vue?vue&type=script&lang=js&"
import style0 from "./SecondChildAction.vue?vue&type=style&index=0&id=47405fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47405fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47405fe8')) {
      api.createRecord('47405fe8', component.options)
    } else {
      api.reload('47405fe8', component.options)
    }
    module.hot.accept("./SecondChildAction.vue?vue&type=template&id=47405fe8&scoped=true&", function () {
      api.rerender('47405fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/albert/albertprod/albertreport/SecondChildAction.vue"
export default component.exports